var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/Breadcrumbs.tsx
import { default as MuiBreadcrumbs } from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { NavigateNextIcon, MoreHorizontalIcon } from "@availity/mui-icon";
import { Link } from "@availity/mui-link";
import { jsx, jsxs } from "react/jsx-runtime";
var Breadcrumb = ({ name, url, target = "_top", LinkProps: LinkProps2 }) => {
  const props = {
    "aria-label": name,
    children: name
  };
  return url ? /* @__PURE__ */ jsx(Link, __spreadProps(__spreadValues(__spreadValues({}, props), LinkProps2), { href: url, target })) : /* @__PURE__ */ jsx(Typography, __spreadValues({}, props));
};
var Breadcrumbs = (_a) => {
  var _b = _a, {
    active,
    children,
    crumbs,
    emptyState = "...",
    homeUrl = "/public/apps/dashboard",
    LinkProps: LinkProps2
  } = _b, rest = __objRest(_b, [
    "active",
    "children",
    "crumbs",
    "emptyState",
    "homeUrl",
    "LinkProps"
  ]);
  return /* @__PURE__ */ jsxs(
    MuiBreadcrumbs,
    __spreadProps(__spreadValues({}, rest), {
      separator: /* @__PURE__ */ jsx(NavigateNextIcon, { fontSize: "xsmall" }),
      slotProps: { collapsedIcon: { className: "breadcrumbs__collapsed-icon" } },
      slots: { CollapsedIcon: MoreHorizontalIcon },
      "aria-label": rest["aria-label"] || "breadcrumbs",
      children: [
        /* @__PURE__ */ jsx(Link, { "aria-label": "Home", href: homeUrl, loadApp: false, children: "Home" }),
        crumbs && crumbs.length > 0 && crumbs.map(({ name = emptyState, url, target }) => /* @__PURE__ */ jsx(Breadcrumb, { name, url, target, LinkProps: LinkProps2 }, name)),
        children,
        /* @__PURE__ */ jsx(Typography, { children: active || emptyState })
      ]
    })
  );
};
export {
  Breadcrumbs
};
